import { Loader2, Sparkles } from "lucide-react";
import { Button } from "~/components/ui/button";

interface AutoFillButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
}

export function AutoFillButton({
  onClick,
  disabled = false,
  isLoading = false,
}: AutoFillButtonProps) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={onClick}
      disabled={disabled || isLoading}
      className="h-auto p-1 text-xs text-muted-foreground hover:text-foreground"
    >
      {isLoading ? (
        <>
          <Loader2 className="mr-1 h-3 w-3 animate-spin" />
          Generating...
        </>
      ) : (
        <>
          <Sparkles className="mr-1 h-3 w-3" />
          Auto-fill
        </>
      )}
    </Button>
  );
}
